import { EventEmitterFactory } from '../event/emitter.factory';
import { WindowService } from '../../service/window/service';
import { BrowserLocation } from './location';

export function BrowserLocationFactory(): BrowserLocation {
  return new BrowserLocation(WindowService(), EventEmitterFactory());
}
